import { apiClient } from '../../../../lib/api-client';
import { ReportResult } from '../../../../types/ReportResult';
import { RetailOrderReportType } from '../type/RetailOrderReportType';

export async function apiGenerateRetailOrderReport(retailOrderID: number, reportType: RetailOrderReportType): Promise<ReportResult> {
    try {
        return await apiClient.get("report/retail-order",
            {
                params:
                {
                    retailOrderID: retailOrderID,
                    reportType: reportType
                }
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
